import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsHistorySmartComponent } from './notifications-history-smart/notifications-history-smart.component';
import { NotificationsHistoryComponent } from './notifications-history/notifications-history.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatListModule } from '@angular/material/list';
import { TimeAgoModule } from 'app/pipes/time-ago/time-ago-pipe.module';
import { RouterModule } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from 'app/components/alert/alert.module';



@NgModule({
  declarations: [
    NotificationsHistorySmartComponent,
    NotificationsHistoryComponent
  ],
  imports: [
    AlertModule,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatBadgeModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDividerModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    ReactiveFormsModule,
    RouterModule,
    TimeAgoModule
  ],
  exports: [
    NotificationsHistorySmartComponent,
    NotificationsHistoryComponent
  ]
})
export class NotificationsHistoryModule { }
